"use strict";
var site = site || {}
site.events = (function () {
  var events = [],
    template = document.querySelector('[data-events-role="event-template"]'),
    form = document.querySelector('[data-events-role="form"]'),
    results = document.querySelector('.events__results'),
    nextPageBtn = document.querySelector('[data-events-role="page+"]'),
    prevPageBtn = document.querySelector('[data-events-role="page-"]'),
    shownElementsText = document.querySelector('[data-events-role="shownElementsText"]'),
    page = 1,
    itemsPerPage = 10

  function addEvent(title, starts, ends, link) {
    events.push(
      {title: title, starts: starts, ends: ends, link: link}
    )
  }

  function filteredAndSortedEvents() {
    var futurePast = form.elements.futurePast.value

    // filter future/past
    return events.filter(
      function (e) {
        if (futurePast === 'future') {
          return e.starts >= (new Date().getTime() / 1000)
        }
        return e.starts < (new Date().getTime() / 1000)
      }
    ).sort( // sort by start datetime
      function (a, b) {
        if (futurePast === 'future') {
          return a.starts - b.starts
        }
        return b.starts - a.starts
      }
    )
  }

  function render() {
    // clean "results" container
    while (results.firstChild) results.removeChild(results.firstChild)

    var filteredAndSorted = filteredAndSortedEvents(),
      numEvents = filteredAndSorted.length,
      firstShown = (page - 1) * itemsPerPage + 1,
      lastShown = Math.min(page * itemsPerPage, numEvents)

    // set pagination status bar text
    if(lastShown >= 1)
    {
      shownElementsText.textContent = firstShown + '-' + lastShown
    }
    else
    {
      shownElementsText.textContent = ''
      results.innerHTML = 'Derzeit sind keine Veranstaltungen geplant.'
      results.classList.add("text-center","py-4","bg-light");
      nextPageBtn.disabled = page = 1
    }

    filteredAndSorted.filter( // pagination
      function (e, index) {
        var lastPage = Math.ceil(numEvents / itemsPerPage)

        prevPageBtn.disabled = page <= 1
        nextPageBtn.disabled = page >= lastPage


        if (page > lastPage) {
          page = lastPage
        }

        return index >= (page - 1) * itemsPerPage && index < page * itemsPerPage
      }
    ).forEach( // render and append to this.results
      function (e) {
        var clone = template.content.cloneNode(true)
        var datetime = new Date(e.starts * 1000)
        var datetimeends = new Date(e.ends * 1000)
        var humanDate = datetime.getDate().toString().padStart(2, '0')
          + '.' + (datetime.getMonth() + 1).toString().padStart(2, '0')
          + '.' + datetime.getFullYear()
        var humanTime = datetime.getHours().toString().padStart(2, '0')
          + ':' + datetime.getMinutes().toString().padStart(2, '0')
        var humanDateEnds = datetimeends.getDate().toString().padStart(2, '0')
          + '.' + (datetimeends.getMonth() + 1).toString().padStart(2, '0')
          + '.' + datetimeends.getFullYear()
        var humanTimeEnds = datetimeends.getHours().toString().padStart(2, '0')
          + ':' + datetimeends.getMinutes().toString().padStart(2, '0')

        if (humanTime === '00:00') {
          humanTime = ''
        } else {
          humanTime = '<span class="clock"></span>' + humanTime
        }

        if (humanTimeEnds === '00:00' || humanTimeEnds === '01:00') {
          humanTimeEnds = ''
        } else {
          humanTimeEnds = ' &ndash; ' + humanTimeEnds
        }

        if (humanDateEnds === humanDate || humanDateEnds === '01.01.1970') {
          humanDateEnds = ''
        } else {
          humanDateEnds = ' &ndash; ' + humanDateEnds
        }

        if (e.link) {
          clone.querySelector('a').href = e.link
        } else { // remove <a>
          var _a = clone.querySelector('a')
          _a.outerHTML = _a.innerHTML
          window.a = _a
        }

        clone.querySelector('.events__starts__date').innerHTML = humanDate.replace(
          /\./g,
          '<span class="events__separator">$&</span>'
        )
        clone.querySelector('.events__starts__time').innerHTML = humanTime.replace(
          /:/g,
          '<span class="events__separator">$&</span>'
        )
        clone.querySelector('.events__ends__date').innerHTML = humanDateEnds.replace(
          /\./g,
          '<span class="events__separator">$&</span>'
        )
        clone.querySelector('.events__ends__time').innerHTML = humanTimeEnds.replace(
          /:/g,
          '<span class="events__separator">$&</span>'
        )
        clone.querySelector('.events__title').innerHTML = e.title

        results.appendChild(clone)
      }
    )
  }

  function prevPage(ev) {
    if (page > 1) {
      page = page - 1
      render()
    }
  }

  function nextPage(ev) {
    page = page + 1
    render()
  }

  function init() {
    form.elements.futurePast[0].onclick = render
    form.elements.futurePast[1].onclick = render

    prevPageBtn.onclick = prevPage
    nextPageBtn.onclick = nextPage

    render()
  }

  return {
    add: addEvent,
    init: init
  }
})()
